export function PasswordChangeConfirmation() {
  return (
    <div className="text-center py-8">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        비밀번호가 변경되었습니다!
      </h4>
      
      <p className="text-sm text-gray-600 mb-4">
        새로운 비밀번호로 안전하게 계정을 보호하세요.
      </p>
      
      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <h5 className="text-sm font-medium text-blue-800 mb-1">보안 안내</h5>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• 새로운 비밀번호를 안전한 곳에 보관하세요</li>
              <li>• 다른 사이트와 동일한 비밀번호 사용을 피하세요</li>
              <li>• 정기적으로 비밀번호를 변경하는 것을 권장합니다</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}